import { useEffect } from "react";

export default function StorybookRedirect() {
  useEffect(() => {
    window.location.replace("/storybook/index.html?path=/docs/overview--guidelines");
  }, []);

  return null;
}
